import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactionPreview } from "frontend-components";
import type { Announcement } from "@dashboard/api/task";
import { useAnnouncementReactions } from "@dashboard/hooks/useAnnouncements";
import { getReactionLabels } from "@dashboard/utils/reactionLabels";
import { useStorage } from "@/hooks/contextHooks";

export function AnnouncementReactionPreview({
    id,
    reactionCounts,
}: Pick<Announcement, "id" | "reactionCounts">) {
    const { t } = useTranslation();
    const { url: storageUrl } = useStorage();
    const [isOpen, setIsOpen] = useState(false);
    const reactionsQuery = useAnnouncementReactions(id, isOpen);

    return (
        <ReactionPreview
            reactionCounts={reactionCounts}
            labels={getReactionLabels(t)}
            maxVisible={2}
            details={{
                attributedReactions: reactionsQuery.data,
                getUserAvatarUrl: (user) =>
                    user.picture && storageUrl ? `${storageUrl}/${user.picture}` : undefined,
                isLoading: reactionsQuery.isPending,
                isError: reactionsQuery.isError,
                labels: {
                    loading: t("common.reactions.loading"),
                    error: t("common.reactions.loadError"),
                    empty: t("common.reactions.empty"),
                },
                onOpenChange: setIsOpen,
            }}
        />
    );
}
